export const INIT = 'PARENTPAGE_INIT'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SET_STUDENTS_OF_PARENT = 'SET_STUDENTS_OF_PARENT';
export const SET_COURSES_OF_STUDENT = 'SET_COURSES_OF_STUDENT';
export const SET_INDEX_OF_REPORT = 'SET_INDEX_OF_REPORT';
export const SET_COURSE_REPORT_OF_STUDENT = 'SET_COURSE_REPORT_OF_STUDENT';
export const SET_PARENT_LOGIN_ACCOUNT = 'SET_PARENT_LOGIN_ACCOUNT';
export const SET_COURSE_OBJ_OF_STUDENT = 'SET_COURSE_OBJ_OF_STUDENT';
export const SET_UPDATED_COURSE_OBJ_OF_STUDENT = 'SET_UPDATED_COURSE_OBJ_OF_STUDENT';
